import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/auth";
import { Search, CheckCircle2, XCircle, History as HistoryIcon } from "lucide-react";

export default function HistoriquePage() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [f, setF] = useState("all"); // all | success | failed

  useEffect(() => {
    axios.get(`${API}/operations`).then(r => setRows(r.data)).catch(() => {});
  }, []);

  const filtered = rows.filter(r => {
    if (f !== "all" && r.status !== f) return false;
    if (!q) return true;
    const s = q.toLowerCase();
    return [r.brand, r.model, r.operation, r.imei, r.serial, r.chipset]
      .some(v => (v || "").toLowerCase().includes(s));
  });

  return (
    <div className="p-6 space-y-6" data-testid="history-page">
      <div className="card-lhs p-6 flex items-center justify-between flex-wrap gap-4">
        <div>
          <div className="text-xs uppercase tracking-widest text-zinc-500 font-mono-tech">Journal</div>
          <h1 className="font-display text-3xl font-extrabold mt-1 flex items-center gap-3">
            <HistoryIcon className="w-7 h-7 text-orange-500" /> Historique
          </h1>
          <p className="text-zinc-400 text-sm mt-1">Toutes vos opérations, tracées et horodatées.</p>
        </div>
        <div className="flex items-center gap-3">
          <div className="relative">
            <Search className="w-4 h-4 text-zinc-500 absolute left-3 top-1/2 -translate-y-1/2" />
            <input
              data-testid="history-search"
              value={q} onChange={(e) => setQ(e.target.value)}
              placeholder="Rechercher (IMEI, modèle, opération)..."
              className="input-lhs pl-9 w-80"
            />
          </div>
          <div className="flex rounded-lg overflow-hidden border border-zinc-800">
            {["all","success","failed"].map(t => (
              <button key={t}
                data-testid={`filter-${t}`}
                onClick={() => setF(t)}
                className={`px-3 py-2 text-xs uppercase tracking-wider font-mono-tech ${f===t?"bg-orange-500 text-black":"text-zinc-400 hover:text-white"}`}>
                {t === "all" ? "Tous" : t === "success" ? "Succès" : "Échecs"}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="card-lhs overflow-hidden">
        <div className="grid grid-cols-12 gap-2 px-4 py-3 text-[11px] uppercase tracking-wider text-zinc-500 font-mono-tech border-b border-zinc-800">
          <div className="col-span-2">Date</div>
          <div className="col-span-2">Marque · Modèle</div>
          <div className="col-span-2">Processeur</div>
          <div className="col-span-2">IMEI</div>
          <div className="col-span-2">Opération</div>
          <div className="col-span-2 text-right">Statut</div>
        </div>
        <div className="divide-y divide-zinc-800/70 max-h-[65vh] overflow-y-auto scroll-thin" data-testid="history-list">
          {filtered.length === 0 && (
            <div className="p-8 text-center text-sm text-zinc-500">Aucune opération pour le moment.</div>
          )}
          {filtered.map((r) => (
            <div key={r.id} className="grid grid-cols-12 gap-2 px-4 py-3 text-xs items-center hover:bg-zinc-900/50" data-testid={`history-row-${r.id}`}>
              <div className="col-span-2 font-mono-tech text-zinc-400">{new Date(r.created_at).toLocaleString("fr-FR")}</div>
              <div className="col-span-2 font-semibold">{r.brand} {r.model || ""}</div>
              <div className="col-span-2 text-zinc-400 font-mono-tech">{r.chipset || "—"}</div>
              <div className="col-span-2 font-mono-tech text-zinc-500">{r.imei || "—"}</div>
              <div className="col-span-2 text-orange-400 font-mono-tech">{r.operation}</div>
              <div className="col-span-2 flex justify-end">
                {r.status === "success"
                  ? <span className="flex items-center gap-1 text-emerald-400"><CheckCircle2 className="w-4 h-4" /> Succès</span>
                  : <span className="flex items-center gap-1 text-red-400"><XCircle className="w-4 h-4" /> Échec</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
